module.exports = __webpack_public_path__ + "img/novosti-embrace.b31a340c.png";